import { GetSessionQuery } from "@/graphql";
import { formatDate } from "@/utils/datetime";

type Session = NonNullable<
  NonNullable<NonNullable<GetSessionQuery["coachSession"]>["session"]>
>;
type Product = NonNullable<
  NonNullable<GetSessionQuery["coachSession"]>["session"]
>["product"];

interface SessionCardProps {
  session: Session;
  product: Product;
}

export function SessionCard({ session, product }: SessionCardProps) {
  return (
    <div className="w-full max-w-2xl rounded-lg border border-gray-300 bg-white p-6 shadow-sm">
      <div className="text-lg font-semibold mb-3">Session Info</div>
      <div className="rounded-lg border border-gray-300 bg-gray-200 p-4 space-y-1">
        <div className="text-sm">
          <span className="font-bold">Coaching Type:</span>{" "}
          <span className="font-normal">{product.specialty?.name}</span>
        </div>
        <div className="text-sm">
          <span className="font-bold">Length:</span>{" "}
          <span className="font-normal">{product.name}</span>
        </div>
        <div className="text-sm">
          <span className="font-bold">Scheduling Window:</span>{" "}
          <span className="font-normal">
            {formatDate(session.targetStartDate, "d MMM yyyy")} -{" "}
            {formatDate(session.targetEndDate, "d MMM yyyy")}
          </span>
        </div>
      </div>
    </div>
  );
}
